import { Center } from "../Center";
import { useLayout } from "../../contexts/Layout";
import { useCrossHair } from "../../contexts/CrossHair";
import { SeekDisplay } from ".";
import Section from "./Section";
import { useRoot } from "../../contexts/Root";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBible, faClock } from "@fortawesome/free-solid-svg-icons";

export const CenteredCrossHairDisplay = () => {
  const {
    theme: { foreground, fadedForeground },
  } = useRoot();
  const { isMobile } = useLayout();
  const { stringifiedTime, markerLabel, show: active } = useCrossHair();
  const show = isMobile && active;

  return (
    <Center show={show}>
      <SeekDisplay show centered>
        <Section
          color={foreground}
          text={stringifiedTime}
          icon={<FontAwesomeIcon icon={faClock} />}
        />
        {markerLabel !== undefined && (
          <Section
            color={fadedForeground}
            text={markerLabel}
            icon={<FontAwesomeIcon icon={faBible} />}
          />
        )}
      </SeekDisplay>
    </Center>
  );
};
